import { render, staticRenderFns } from "./book-detail.vue?vue&type=template&id=6cff01f0&"
import script from "./book-detail.vue?vue&type=script&lang=js&"
export * from "./book-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports